import { USER_PREFERENCE_SETS } from 'common/utils/constants';

export const ActionTypes = {
  ADD: 'USER_PREFERENCE_ADD',
  UPDATE: 'USER_PREFERENCE_UPDATE',
  REMOVE: 'USER_PREFERENCE_REMOVE',
  REQUEST: 'USER_PREFERENCE_REQUEST',
  SUCCESS: 'USER_PREFERENCE_SUCCESS',
  FAILURE: 'USER_PREFERENCE_FAILURE'
};

export const defaultPreferenceIds = {
  [USER_PREFERENCE_SETS.CHART]: null,
  [USER_PREFERENCE_SETS.CHART_SET]: 'local_chart_set_0'
};

export const localChartPlaceholder = {
  preferenceId: 'chart_placeholder',
  name: '',
  category: USER_PREFERENCE_SETS.CHART,
  default: false,
  local: true,
  state: {
    version: '1',
    query: {
      time: { span: 'week' },
      counters: [{ name: 'systemTemp', aggregation: 'avg' }],
      actions: ['reboot']
    },
    datasets: [
      {
        key: 'systemTemp',
        type: 'line',
        label: 'systemTemp',
        xAxis: 'x',
        yAxis: 'y'
      }
    ],
    scales: [
      {
        key: 'x',
        label: 'Time',
        position: 'bottom'
      },
      {
        key: 'y',
        label: 'Temperature (°C)',
        position: 'left'
      }
    ]
  }
};

export const localPreferences = [
  {
    preferenceId: 'local_chart_set_0',
    name: 'Charts',
    category: USER_PREFERENCE_SETS.CHART_SET,
    default: false,
    local: true,
    state: {
      version: '1',
      query: {
        time: { span: 'week' }
      },
      charts: [
        { preferenceId: 'local_chart_0', category: 'chart', local: true, query: { actions: ['reboot'] } },
        { preferenceId: 'local_chart_1', category: 'chart', local: true, query: { actions: ['reboot'] } },
        { preferenceId: 'local_chart_2', category: 'chart', local: true, query: { actions: ['reboot'] } }
      ]
    }
  },
  {
    preferenceId: 'local_chart_0',
    name: 'Device Temperature',
    category: USER_PREFERENCE_SETS.CHART,
    default: false,
    local: true,
    state: {
      version: '1',
      query: {
        time: { span: 'week' },
        counters: [{ name: 'systemTemp', aggregation: 'avg' }],
        actions: ['reboot']
      },
      datasets: [
        {
          key: 'systemTemp',
          type: 'line',
          label: 'systemTemp',
          xAxis: 'x',
          yAxis: 'y'
        }
      ],
      scales: [
        {
          key: 'x',
          label: 'Time',
          position: 'bottom'
        },
        {
          key: 'y',
          label: 'Temperature (°C)',
          position: 'left'
        }
      ]
    }
  },
  {
    preferenceId: 'local_chart_1',
    name: 'Downlink Power',
    category: USER_PREFERENCE_SETS.CHART,
    default: false,
    local: true,
    state: {
      version: '1',
      query: {
        time: { span: 'week' },
        counters: [
          { name: 'PanelPower_HPolDL', aggregation: 'avg' },
          { name: 'PanelPower_VPolDL', aggregation: 'avg' }
        ],
        actions: ['reboot']
      },
      datasets: [
        {
          key: 'PanelPower_HPolDL',
          type: 'line',
          label: 'PanelPower_HPolDL',
          xAxis: 'x',
          yAxis: 'y'
        },
        {
          key: 'PanelPower_VPolDL',
          type: 'line',
          label: 'PanelPower_VPolDL',
          xAxis: 'x',
          yAxis: 'y'
        }
      ],
      scales: [
        {
          key: 'x',
          label: 'Time',
          position: 'bottom'
        },
        {
          key: 'y',
          label: 'RF Power (dBm)',
          position: 'left'
        }
      ]
    }
  },
  {
    preferenceId: 'local_chart_2',
    name: 'Uplink Power',
    category: USER_PREFERENCE_SETS.CHART,
    default: false,
    local: true,
    state: {
      version: '1',
      query: {
        time: { span: 'week' },
        counters: [
          { name: 'PanelPower_HPolUL', aggregation: 'avg' },
          { name: 'PanelPower_VPolUL', aggregation: 'avg' }
        ],
        actions: ['reboot']
      },
      datasets: [
        {
          key: 'PanelPower_HPolUL',
          type: 'line',
          label: 'PanelPower_HPolUL',
          xAxis: 'x',
          yAxis: 'y'
        },
        {
          key: 'PanelPower_VPolUL',
          type: 'line',
          label: 'PanelPower_VPolUL',
          xAxis: 'x',
          yAxis: 'y'
        }
      ],
      scales: [
        {
          key: 'x',
          label: 'Time',
          position: 'bottom'
        },
        {
          key: 'y',
          label: 'RF Power (dBm)',
          position: 'left'
        }
      ]
    }
  },
  {
    preferenceId: 'local_chart_3',
    name: 'RSRP',
    category: USER_PREFERENCE_SETS.CHART,
    default: false,
    local: true,
    state: {
      version: '1',
      query: {
        time: { span: 'week' },
        counters: [{ name: 'lte_rsrp', aggregation: 'avg' }],
        actions: ['reboot']
      },
      datasets: [{ key: 'lte_rsrp', type: 'line', label: 'lte_rsrp', xAxis: 'x', yAxis: 'y' }],
      scales: [
        { key: 'x', position: 'bottom', label: 'Time' },
        { key: 'y', position: 'left', label: 'lte_rsrp' }
      ]
    }
  },
  {
    preferenceId: 'local_chart_4',
    name: 'RSRQ',
    category: USER_PREFERENCE_SETS.CHART,
    default: false,
    local: true,
    state: {
      version: '1',
      query: {
        time: { span: 'week' },
        counters: [{ name: 'lte_rsrq', aggregation: 'avg' }],
        actions: ['reboot']
      },
      datasets: [{ key: 'lte_rsrq', type: 'line', label: 'lte_rsrq', xAxis: 'x', yAxis: 'y' }],
      scales: [
        { key: 'x', position: 'bottom', label: 'Time' },
        { key: 'y', position: 'left', label: 'lte_rsrq' }
      ]
    }
  },
  {
    preferenceId: 'local_chart_5',
    name: 'RSRP',
    category: USER_PREFERENCE_SETS.CHART,
    default: false,
    local: true,
    state: {
      version: '1',
      query: {
        time: { span: 'week' },
        counters: [{ name: 'modem-rsrp-avg', aggregation: 'avg' }],
        actions: ['reboot']
      },
      datasets: [{ key: 'modem-rsrp-avg', type: 'line', label: 'lte-rsrp', xAxis: 'x', yAxis: 'y' }],
      scales: [
        { key: 'x', position: 'bottom', label: 'Time' },
        { key: 'y', position: 'left', label: 'lte_rsrp' }
      ]
    }
  },
  {
    preferenceId: 'local_chart_6',
    name: 'RSRQ',
    category: USER_PREFERENCE_SETS.CHART,
    default: false,
    local: true,
    state: {
      version: '1',
      query: {
        time: { span: 'week' },
        counters: [{ name: 'modem-rsrq-avg', aggregation: 'avg' }],
        actions: ['reboot']
      },
      datasets: [{ key: 'modem-rsrq-avg', type: 'line', label: 'lte_rsrq', xAxis: 'x', yAxis: 'y' }],
      scales: [
        { key: 'x', position: 'bottom', label: 'Time' },
        { key: 'y', position: 'left', label: 'lte_rsrq' }
      ]
    }
  },
  localChartPlaceholder
];

export const defaultState = {
  byId: localPreferences.reduce((acc, preference) => {
    acc[preference.preferenceId] = preference;

    return acc;
  }, {}),
  byCategory: {},
  error: null,
  loaded: false,
  loading: false
};

export const defaultCategoryState = {
  ids: [],
  defaultId: null,
  loaded: false,
  loading: false,
  error: null
};
